const transformFileType = (fileType: string | undefined): string => {
  switch (fileType?.toLowerCase()) {
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'pdf':
      return 'application/pdf';
    case 'xls':
      return 'application/vnd.ms-excel';
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'doc':
      return 'application/msword';
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    case 'csv':
      return 'text/csv';
    case 'txt':
      return 'text/plain';
    case 'zip':
      return 'application/zip';
    default:
      return 'application/octet-stream'; // default fallback
  }
};

const cleanFilename = (filename: string | undefined): string => {
  if (!filename) return '';
  const lastDotIndex = filename.lastIndexOf('.');

  const namePart = lastDotIndex !== -1 ? filename.slice(0, lastDotIndex) : filename;
  const extension = lastDotIndex !== -1 ? filename.slice(lastDotIndex) : '';
  const sanitizedWord = (word: string) => {
    // Remove any non-printable or non-ASCII characters

    //conatins special characters
    if (/[^a-zA-Z0-9]/.test(word)) {
      // Remove special characters
      return word.replace(/[^a-zA-Z0-9]/g, '');
    }

    return word
      .normalize('NFD') // Break accented chars into base + accent
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^\d ]/g, '')
      .replace(/\s+/g, '') // Optional: remove all spaces
      .trim();
  };

  const words = namePart.split(/\s+/);
  let sanitizedFilename = '';
  words.forEach((word, index) => {
    //validate each word has only valid characters
    const isValid = /^[\w\s.-]+$/.test(word);
    if (!isValid) {
      // If the word is invalid, replace it with a sanitized version
      words[index] = sanitizedWord(word);
    }
    sanitizedFilename += words[index] + ' ';
  });
  return extension && extension !== '' // If the file extension is not empty, add it back to the filename
    ? sanitizedFilename.trim() + extension.trim()
    : sanitizedFilename.trim(); // Add the file extension back
  // Normalize weird unicode into standard form
};
export { transformFileType, cleanFilename };
